module.exports = __webpack_public_path__ + "img/introduce1-arrow.6f256a39.png";